<template>
  <div :class="{'is-flex-grow-1': isImagePaysage && logo && readOnly}">
    <div v-if="readOnly && !autoSave" class="is-position-relative"
        :class="{
          'height-100': imageFillHeightKeepAspectInView && logo,
          'height-151': !(imageFillHeightKeepAspectInView && logo),
          }"
    >
      <img
        class="image logo-img"
        :class="{
          'is-cursor-pointer' : logo && elementId,
          'shrink-height': isImagePaysage && !imageFillHeightKeepAspectInView,
          'is-fullwidth': isImagePaysage && logo,
        }"
        @click="showLogo()"
        :src="logo ? `${imageFillHeightKeepAspectInView ?
            logo.chemin || logo.cheminMin : logo.cheminMin || logo.chemin}` :
                  '/static/img/default-placeholder.png'"
        ref="clogo"
        @load="getImageDimensions"
        alt="Logo"/>
    </div>
    <div v-else-if="piecesJointesConfiguration || autoSave"
      class="is-position-relative height-151">
      <uploader @added="actionFileAdd" name="logo"
                  class=" is-cursor-pointer"
                  ref="upload"
                  :extensions="/\.(gif|jpe?g|png|webp|bmp)$/i"
                  accept="image/*"
                  @filePrevented="filePrevented"
                  :size="piecesJointesConfiguration.maxSize || taillePjLimite"
                  post-action="">
        <b-icon
          v-if="(file || logo)  && autoSave "
          class="upload-update-btn mgr-15px mgt-10px"
          icon="pencil"
          type="is-grey-lighter">
        </b-icon>
      </uploader>
      <b-icon
        v-if="file || logo"
        class="upload-close-btn has-background-background"
        icon="close-circle"
        type="is-grey-lighter"
        @click.native="fileAdded(null)">
      </b-icon>
      <label for="logo" class="height-inherit is-cursor-pointer" @click="showLogo()">
        <uploader @added="actionFileAdd" name="logo"
                  class="upload-box has-background-light is-cursor-pointer
                    is-fullwidth is-height-inherit"
                  ref="upload"
                  :extensions="/\.(gif|jpe?g|png|webp|bmp)$/i"
                  accept="image/*"
                  @filePrevented="filePrevented"
                  :size="piecesJointesConfiguration.maxSize || taillePjLimite"
                  post-action="">
          <img v-if="file" :src="file.blob"
              @load="getImageDimensions"
              :class="{ 'shrink-height': isImagePaysage }"
              ref="clogo"
              alt="" class="logo-img">
          <img v-else-if="logo" @load="getImageDimensions"
              :class="{ 'shrink-height': isImagePaysage }"
              ref="clogo"
              :src="`${logo.cheminMin || logo.chemin || logo.thumb}`"
              alt="" class="logo-img">
          <div v-else class="logo">
            <b-icon
              icon="plus-circle"
              size="is-large"
              class="is-cursor-pointer logo-plus"
              type="is-grey-lighter">
            </b-icon>
          </div>
        </uploader>
      </label>
    </div>
    <b-modal v-model="popUpPrevention" has-modal-card class="modal">
      <pop-up-prevention :mess-header="$t('general.popUpSuppresionPjImage.title.image')"
                         :mess-footer="$t('general.popUpSuppresionPjImage.sousTitle.edition')"
                         :cancel="$t('general.button.cancel')"
                         :validate="$t('general.button.next')"
                         @no="popUpPrevention=false"
                         @yes="deleteLogo">
      </pop-up-prevention>
    </b-modal>
    <b-modal
      v-model="popUpResizeLogo"
      id="modal_cropper">
      <resize-img
        :data-file="resizeFile"
        :noCropper="nocropper"
        :canConserveAncienne="canConserveAnciennePj"
        @img-resize="fileAdded">
      </resize-img>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/modules/attachments-mutation-type';
import { TAILLE_PJ_LIMITE } from '@/configuration/piecesJointes';
import messageInformation from '@/services/general/messageInformation';
import popUpPrevention from '@/components/general/popUpPrevention';
import ResizeImg from '@/components/general/resize-img';
import messageErreur from '@/services/general/messageErreur';
import Uploader from './uploader';

const Attachments = createNamespacedHelpers('attachments');

export default {
  name: 'GeneralLogo',
  props: {
    readOnly: {
      type: Boolean,
    },
    noCropper: {
      type: Boolean,
      default: null,
    },
    elementId: {
      type: String,
      required: false,
    },
    libelleElement: {
      type: String,
      required: false,
    },
    autoSave: {
      type: Boolean,
    },
    imageFillHeightKeepAspectInView: {
      type: Boolean,
    },
    canConserveAncienne: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Uploader,
    popUpPrevention,
    ResizeImg,
  },
  computed: {
    ...Attachments.mapGetters({
      piecesJointesConfiguration: 'configuration',
      logo: 'logo',
    }),
    isImagePaysage() {
      if (!this.imageHeight || !this.imageWidth) {
        return false;
      }
      return (this.imageWidth / this.imageHeight) >= 2;
    },
    canConserveAnciennePj() {
      if (this.autoSave) return this.canConserveAncienne && !!this.logo;
      return this.canConserveAncienne;
    },
  },
  data() {
    return {
      file: null,
      resizeFile: null,
      taillePjLimite: TAILLE_PJ_LIMITE,
      popUpPrevention: false,
      popUpResizeLogo: false,
      imageWidth: null,
      imageHeight: null,
      nocropper: false,
    };
  },
  mounted() {
    this.nocropper = this.noCropper || false;
  },
  methods: {
    ...Attachments.mapMutations({
      setLogo: types.SET_LOGO,
    }),
    ...Attachments.mapActions({
      updateAttachments: 'update',
      loadAttachments: 'loadAttachments',
    }),
    async deleteLogo() {
      this.setLogo(null);
      this.file = null;
      if (this.autoSave && this.$route.params.id) {
        await this.updatePieceJointe();
      }
      this.popUpPrevention = false;
    },
    actionFileAdd(file) {
      if (!file) {
        this.popUpPrevention = true;
        return;
      }
      this.resizeFile = file;
      this.popUpResizeLogo = true;
    },
    async fileAdded(file) {
      this.popUpResizeLogo = false;
      if (!file) {
        this.popUpPrevention = true;
        return;
      }
      this.file = file;
      this.setLogo({
        size: file.size,
        description: file.description,
        typeId: file.groupType,
        nom: file.name,
        thumb: file.thumb,
        file: file.file,
        compressedFile: file.compressedFile,
        placeType: 'Logo',
        conserveAnciennePj: file.conserveAnciennePj,
      });
      this.$emit('hasNewFile', true);
      if (this.autoSave && this.$route.params.id) {
        await this.updatePieceJointe();
        if (this.file.conserveAnciennePj) {
          await this.loadAttachments();
        }
      }
    },
    filePrevented(error) {
      messageInformation(error.message, 'is-danger');
    },
    showLogo() {
      if (!(this.logo && this.elementId)) return;
      const url = this.$router.resolve({
        name: 'detail-image-produit',
        params: { id: this.elementId, libelle: this.libelleElement },
      });
      window.open(url.href, '_blank');
    },
    async updatePieceJointe() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.updateAttachments(this.$route.params.id);
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    getImageDimensions() {
      const image = this.$refs.clogo;
      const width = image.naturalWidth;
      const height = image.naturalHeight;
      this.imageWidth = width;
      this.imageHeight = height;
    },
  },
};
</script>
